// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3tz5H","options":"AnswerScale_options__3QNIj","selected":"AnswerScale_selected__1Cypn"};